import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Title } from "@angular/platform-browser";

const BASE_TITLE = 'Assessment Planner';

export class BaseUiService {

  protected focusSelector = '.p-tabview-panel:not([hidden]) .autofocus';
  protected focusInputSelector = '.layout-content form input:not([disabled])';

  constructor(
    protected messageService: MessageService,
    protected transloco: TranslocoService,
    protected confirmation: ConfirmationService,
    protected title: Title
  ) { }

  public toastSuccess(message: string, topline = null): void {
    this.messageService.add({
      key: 'toast',
      severity: 'success',
      summary: topline || this.transloco.translate('common.success'),
      detail: message
    });
  }

  public toastError(message: string, topline = this.transloco.translate('common.error'), life = 3000): void {
    this.messageService.add({
      key: 'toast',
      severity: 'error',
      summary: topline,
      detail: message,
      life
    });
  }

  public toastInfo(message: string, topline = this.transloco.translate('common.labels.info'), life = 3000): void {
    this.messageService.add({
      key: 'toast',
      severity: 'info',
      summary: topline,
      detail: message,
      life
    });
  }

  public showMessage(type: string, message: string, topline = ''): void {
    this.messageService.add({
      severity: type,
      summary: topline,
      detail: message
    });
    this.scrollToMessages();
  }

  public hideMessage(): void {
    this.messageService.clear();
  }

  public setFocus(selector: string = null): void {
    if (selector === null) {
      selector = this.focusSelector;
    }
    setTimeout(() => {
      const focus: any = document.querySelector(selector);
      if (focus !== null) {
        focus.focus();
      }
    }, 100);
  }

  public setFormFocus(): void {
    this.setFocus(this.focusInputSelector);
  }

  public setPageTitle(subtitle: string): void {
    this.title.setTitle(BASE_TITLE + ' - ' + subtitle);
  }

  public scrollToMessages(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  public copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.toastSuccess(
        this.transloco.translate('common.labels.copying_to_clipboard_successfull'),
        this.transloco.translate('common.success')
      );
    }, () => {
    });
  }

  public showConfirm(message: string, header: string = null, acceptFunction: Function): void {
    this.confirmation.confirm({
      message: message,
      header: header || this.transloco.translate('common.labels.info'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.transloco.translate('common.labels.ok'),
      rejectLabel: this.transloco.translate('common.labels.cancel'),
      rejectButtonStyleClass: 'p-button-outlined',
      acceptIcon: '',
      accept: () => {
        acceptFunction();
      }
    });
  }
}
